import DOMPurify from 'dompurify';

/** Sanitize user/server HTML before dangerouslySetInnerHTML. */
export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
}

/** True when sanitized HTML has visible text (not empty tags). */
export function htmlHasVisibleText(html: string | null | undefined): boolean {
  if (!html?.trim()) return false;
  const clean = sanitizeHtml(html);
  if (!clean.trim()) return false;
  const doc = new DOMParser().parseFromString(clean, 'text/html');
  return Boolean(doc.body.textContent?.trim());
}
